var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            title: "Editar senha do usuário",
            "hide-footer": "",
            centered: ""
          },
          on: { shown: _vm.onModalShown },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "bg-white border rounded-lg p-2 d-flex align-items-center mb-3"
            },
            [
              _c(
                "div",
                {
                  staticClass: "bg-light border rounded p-2 mr-2",
                  attrs: { "aria-hidden": "true" }
                },
                [_c("i", { staticClass: "fas fa-user-lock" })]
              ),
              _vm._v(" "),
              _c("div", [
                _c("h6", { staticClass: "mb-0 font-weight-bold" }, [
                  _vm._v("Defina uma nova senha")
                ]),
                _vm._v(" "),
                _c("small", [
                  _vm._v(" Use pelo menos "),
                  _c("strong", [_vm._v("8 caracteres")]),
                  _vm._v(", com "),
                  _c("strong", [_vm._v("letra")]),
                  _vm._v(" e "),
                  _c("strong", [_vm._v("número")]),
                  _vm._v(".")
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "userUpdatePasswordForm",
              attrs: {
                model: _vm.payload,
                "label-position": "top",
                "status-icon": "",
                rules: _vm.rules
              }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "password" } },
                        [
                          _c("label", [_vm._v("Senha")]),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              type: "password",
                              placeholder: "Digite a nova senha",
                              disabled: _vm.isLoading,
                              autocomplete: "off",
                              "show-password": ""
                            },
                            model: {
                              value: _vm.payload.password,
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "password", $$v)
                              },
                              expression: "payload.password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "password_confirmation" } },
                        [
                          _c("label", [_vm._v("Confirmar senha")]),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              type: "password",
                              placeholder: "Confirme a nova senha",
                              disabled: _vm.isLoading,
                              autocomplete: "off",
                              "show-password": ""
                            },
                            model: {
                              value: _vm.payload.password_confirmation,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.payload,
                                  "password_confirmation",
                                  $$v
                                )
                              },
                              expression: "payload.password_confirmation"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    [
                      _c("el-form-item", { attrs: { prop: "status" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-items-center",
                            style: { gap: "8px" }
                          },
                          [
                            _c("el-switch", {
                              model: {
                                value: _vm.payload.reset_password,
                                callback: function($$v) {
                                  _vm.$set(_vm.payload, "reset_password", $$v)
                                },
                                expression: "payload.reset_password"
                              }
                            }),
                            _vm._v(
                              "\n                            Alterar senha no próximo acesso?\n                        "
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm.payload.reset_password
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "bg-white border rounded-lg p-2 d-flex align-items-center mb-3"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bg-light border rounded p-2 mr-2",
                                  attrs: { "aria-hidden": "true" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-warning-outline"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("small", [
                                _vm._v(
                                  "A senha será alterada imediatamente, e o usuário precisará usar a nova senha para acessar o sistema."
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-end"
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  plain: "",
                                  disabled: _vm.isLoading
                                },
                                on: {
                                  click: function() {
                                    _vm.toggleModal()
                                    _vm.resetForm()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Cancelar\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled: _vm.isLoading || _vm.userId == null
                                },
                                on: { click: _vm.onSubmit }
                              },
                              [
                                _vm._v(
                                  "\n                                Salvar\n                                "
                                ),
                                _vm.isLoading
                                  ? _c("i", { staticClass: "el-icon-loading" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("i", { staticClass: "fas fa-check-circle" })
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65e92420", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65e92420","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/User/UserEditPasswordModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-65e92420","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/User/UserEditPasswordModal.vue
// module chunks = 2